<div class="modal-header">
    <h5 class="modal-title">{{ isEditMode ? 'Entegrasyon Güncelle' : 'Yeni Entegrasyon Ekle' }}</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="integrationForm">
  
      <div class="mb-3">
        <label for="userName" class="form-label">Kullanıcı Adı</label>
        <input type="text" class="form-control" formControlName="userName" />
        <div *ngIf="f.userName.touched && f.userName.invalid" class="text-danger">
          Kullanıcı adı boş bırakılamaz.
        </div>
      </div>
  
      <div class="mb-3">
        <label for="password" class="form-label">Şifre / API Key</label>
        <input type="text" class="form-control" formControlName="password" />
        <div *ngIf="f.password.touched && f.password.invalid" class="text-danger">
          Şifre boş bırakılamaz.
        </div>
      </div>
  
      <!-- Mail entegrasyon alanları -->
      <div *ngIf="isMailIntegration">
        <div class="mb-3">
          <label for="smtpServer" class="form-label">SMTP Server</label>
          <input type="text" class="form-control" formControlName="smtpServer" />
        </div>
  
        <div class="mb-3">
          <label for="smtpPort" class="form-label">SMTP Port</label>
          <input type="number" class="form-control" formControlName="smtpPort" />
        </div>
  
        <div class="mb-3 form-check">
          <input type="checkbox" class="form-check-input" formControlName="useSSL" id="useSSL" />
          <label class="form-check-label" for="useSSL">SSL Kullan</label>
        </div>
  
        <div class="mb-3">
          <label for="senderEmail" class="form-label">Gönderici Email</label>
          <input type="email" class="form-control" formControlName="senderEmail" />
          <div *ngIf="f.senderEmail.touched && f.senderEmail.invalid" class="text-danger">
            Geçerli bir email giriniz.
          </div>
        </div>
  
        <div class="mb-3">
          <label for="senderName" class="form-label">Gönderici Adı</label>
          <input type="text" class="form-control" formControlName="senderName" />
        </div>
      </div>
  
      <!-- Sadece edit modda gösterilecek durum -->
      <div class="mb-3" *ngIf="isEditMode">
        <label class="form-label">Durum</label>
        <select class="form-control" formControlName="isActive">
          <option [value]="true">Aktif</option>
          <option [value]="false">Pasif</option>
        </select>
      </div>
  
    </form>
  </div>
  
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">İptal</button>
    <button class="btn btn-primary" (click)="submit()" [disabled]="integrationForm.invalid">
      {{ isEditMode ? 'Güncelle' : 'Kaydet' }}
    </button>
  </div>
  